import { render, staticRenderFns } from "./ChannelTab.vue?vue&type=template&id=2b8fc159"
import script from "./ChannelTab.vue?vue&type=script&lang=js"
export * from "./ChannelTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports